module.exports = __webpack_public_path__ + "img/whastlistingServices.af0af806.svg";